export const accordionData = [
  {
    title: 'SLIIT',
    content: `B.Sc. Special (Hons) – Information Technology (Specialization – Information Technology) Sri Lanka Institute of Information Technology GPA 3.06 Second Class (Lower Division) (January 2014 - March 2018).
      <br><br>Selected to Deans' List 4th year 2nd semester`
  },
  {
    title: 'CIMA',
    content: `Completed 3 subjects in CIMA Foundation Level - 2013.`
  },
  {
    title: 'Isipathana College',
    content: `G.C.E Advanced Level in Isipathana College - Aug 2012<br>
      • Accounting ( A )<br>
      • Business Studies ( B )<br>
      • Econ ( B )`
  }
];

export const myworkexpreice = [
  {
    "datetimeto": "2018-11T2019-11",
    "tag": "Nov 2018 - Apr 2021",
    "position": "Software Engineer",
    "image": "hnbAssurance",
    "company": "HNB Assurance PLC",
    "description": "<b>&#8226; ORACLE EBS</b> - <br> &nbsp;&nbsp;Laravel, SOAP, RabbitMQ and Oracle DB <b> <br> &#8226; Customer Survey </b> - <br> &nbsp;&nbsp;Ionic, Laravel and MySQL  <br><b>&#8226; Integrate Amex and CyberSource to HNB Pay online </b>  <br><b>&#8226; Commission Dashboard</b> - <br> &nbsp;&nbsp; Angular <br> <b>&#8226; Excel To Database</b> - <br> &nbsp;&nbsp; PHP and oracle DB   <br> <b>&#8226; Quotation System , ONE UI System</b> - <br> &nbsp;&nbsp; .Net Core using dapper, Oracle DB, Angular 6 <br> <b>&#8226; Trainers’ Travelling System</b> - <br> &nbsp;&nbsp;.NET (web form), jQuery, Oracle DB, SQL Server Reporting Services (SSRS) <br> <b>&#8226; Sales Force System</b> - <br> &nbsp;&nbsp;Laravel and Oracle DB"
  }, {
    "datetimeto": "2017-07T2018-11",
    "tag": "Jul 2017 - Nov 2018",
    "position": "Associate Software Engineer",
    "image": "/lankacom.png",
    "company": "Lanka Communication Services (Pvt) Ltd",
    "description": "<b>&#8226; Payroll System</b> <br> &nbsp;&nbsp; Developed 2 New versions of Payroll System. <br> &nbsp;&nbsp; Deployed Payroll System to 6 New Companies.<br> &nbsp;&nbsp; Client support and Requirement Gathering. <br> <b>&#8226; Involved in developing E-swabhimani Voting System and Public Wi-Fi System Logger.</b>"
  }
];



